module.exports = "<div class=\"mr10 ml10 ecat-category-graph\" data-category-id={{categoryGraphVM.category.categoryId}} flex></div> ";